import invoicesData from './sample.json';
import { IInvoice } from '../../accounts/paymentAndBilling/types';
import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { ListParams, buildQueryParams } from '../../utils';
import { Ifilter } from '../../../components/common/filters/interfaces';
import { ThunkAPI } from '../../rootReducer';
import { HttpMethods, SERVICES } from '../../../services/api';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import apiAsyncThunkCreator from '../../../services/apiAsyncThunkCreator';

export const invoices: IInvoice[] = invoicesData.map(invoice => ({
  ...invoice,
  createdAt: new Date(invoice.createdAt),
  updatedAt: new Date(invoice.updatedAt),
  sentDate: new Date(invoice.sentDate),
  closeDate: new Date(invoice.closeDate),
  dueDate: new Date(invoice.dueDate)
}));

export const fetchInvoices: AsyncThunk<{ invoices: IInvoice[]; nextPage: string | undefined }, ListParams<Ifilter[]>, ThunkAPI> = createAsyncThunk(
  'invoicesList/fetch',
  (searchParams: ListParams<Ifilter[]>, thunk) => {
    if (!isFeatureEnabled(Features.PlgExternal3)) {
      return {
        invoices,
        nextPage: undefined
      };
    }
    return apiAsyncThunkCreator<{ invoices: IInvoice[]; nextPage: string | undefined }, void>({
      endpoint: `invoices/${buildQueryParams(searchParams)}`,
      microservice: SERVICES.USERS_SERVICE,
      authenticated: true,
      method: HttpMethods.Get
    })(undefined, thunk);
  }
);
